import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EndpointService } from '@app/core';
import { ToastrService } from 'ngx-toastr';
import { ConsecutiveAtc } from '@app/shared/models/consecutive-atc.models';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ManagementConsecutiveActDataService {

  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) { }


  /**
   * Retorna todos los registros de dias festivos
   *
   * @returns {Observable<ConsecutiveAtc[]>}
   * @memberof ManagementConsecutiveActDataService
   */
  getConsecutives(): Observable<ConsecutiveAtc[]> {
    return new Observable(obs => {
      this.http.get<ConsecutiveAtc[]>(this.api.get('adminConsecutiveAct')).subscribe(
        consecutives => {
          obs.next(consecutives);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Agregar un rango de consecutivos
   *
   * @param {ConsecutiveAtc} consecutive
   * @returns {Promise<boolean>}
   * @memberof ManagementConsecutiveActDataService
   */
  addConsecutive(consecutive: ConsecutiveAtc): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.post<boolean>(this.api.get('adminConsecutiveAct'), consecutive).subscribe(
        _resp => {
          this.toastr.success('Rango de consecutivos agregado correctamente' , 'Operación exitosa');
          resolve(true);
        },
        err => {
          if(err.status == 400 && err.error){
            if (err.error.non_field_errors && err.error.non_field_errors.length > 0){
              this.toastr.warning(err.error.non_field_errors[0], 'Error');
            }else{
              this.toastr.warning("La información suministrada es incorrecta, por favor verifíquela y vuelva a intentarlo.", 'Error');
            }
          }else if(err.status == 500){
            this.toastr.error('Error en el servidor', 'Error');
          }
          reject(err);
        }
      );
    });
  }

  /**
   * Actualizar un rango de consecutivos
   *
   * @param {number} id
   * @param {ConsecutiveAtc} consecutive
   * @returns {Promise<boolean>}
   * @memberof ManagementConsecutiveActDataService
   */
  updateConsecutive(id: number, consecutive: ConsecutiveAtc): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.put<boolean>(this.api.get('adminConsecutiveAct', [id]), consecutive).subscribe(
        _resp => {
          this.toastr.success('Rango de consecutivos modificado correctamente' , 'Operación exitosa');
          resolve(true);
        },
        err => {
          if(err.status == 400 && err.error){
            if (err.error.non_field_errors && err.error.non_field_errors.length > 0){
              this.toastr.warning(err.error.non_field_errors[0], 'Error');
            }else{
              this.toastr.warning("La información suministrada es incorrecta, por favor verifíquela y vuelva a intentarlo.", 'Error');
            }
          }else if(err.status == 500){
            this.toastr.error('Error en el servidor', 'Error');
          }
          reject(err);
        }
      );
    });
  }

  /**
   * Eliminar una rango de consecutivos
   *
   * @param {number} id
   * @returns {Promise<boolean>}
   * @memberof ManagementConsecutiveActDataService
   */
  deleteConsecutive(id: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.delete<boolean>(this.api.get('adminConsecutiveAct', [id])).subscribe(
        _resp => {
          this.toastr.success('Rango de consecutivos eliminado correctamente' , 'Operación exitosa');
          resolve(true);
        },
        err => {
          if(err.status == 400 && err.error){
            if (err.error.non_field_errors && err.error.non_field_errors.length > 0){
              this.toastr.warning(err.error.non_field_errors[0], 'Error');
            }else{
              this.toastr.warning("No es posible eliminar el rango de consecutivos porque tiene consecutivos en uso.", 'Error');
            }
          }else if(err.status == 500){
            this.toastr.error('Error en el servidor', 'Error');
          }
          reject(err);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/management-consecutive-act/shared/management-consecutive-act-data.service.ts